import { MinusCircleIcon } from "@heroicons/react/24/outline";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, GetCommanWay, ListCommanWay, UpdateBookingCommanWay, UpdateCommanWay } from "API/commonApi";
import { AxiosResponse } from "axios";
import { Button, Input } from "components";
import { InputTable } from "components/DataTable/InputTable";
import { useFormik } from "formik";
import { debounce } from "lodash";
import moment from "moment";
import { any } from "prop-types";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import { roles } from "utils/constant";
import handleWheel from "utils/handleOnWheel";
import { AfDataType as ADT } from "utils/TableColumnData";
import { number, object, string } from "yup";

type OptionType = {
  value: number;
  label: string;
};

interface MotherBagState {
  mode?: string;
  data?: { [key: string]: any }; // Adjust the type based on your data structure
  // Add other properties if needed
}

interface ValuesType {
  destination?: { value: string; label: string };
}

const Overedge: React.FC = ({}) => {
  let isDisabled = false;
  const navigate = useNavigate();
  const { state } = useLocation();
  const { mode = "add", data = {} } = (state || {}) as MotherBagState; // Check for existence and type assertion

  const [awbScanVal, setAwbScanVal] = useState<any>("");
  const [acceptedAwbNos, setAcceptedAwbNos] = useState<any>([]);

  /*const [awbTrackingData, setAwbTrackingData] = useState<any>({
    tracking_data: [],
    bookingDate: "",
    awbData: {},
    bookingData: {},
  });*/
  const [awbList, setAwbList] = useState<any[]>([]);
  const [deliveryDoneInfo, setDeliveryDoneInfo] = useState<any>({});
  const [productList, setProductList] = useState<any>([]);
  const [showVolume, setShowVolume] = useState<any>(false);

  const [dataList, setDataList] = useState<any>([]);
  

  const onInputAWB = (no) => {};

  const { mutate: mutateSearchAwb, isLoading: isUpdateAWBloading } = useMutation(
    (awbNo) => GetCommanWay("/admin/proof_of_delivery/track/" + awbNo, {}, {}),
    {
      onSuccess: (data: any) => {
        console.log(data, data.status == "SUCCESS");
        if (data.status == "SUCCESS") {
          let oldAwbList = [...awbList];
          oldAwbList.push(data.data);
          setAwbList(oldAwbList);
          setAwbScanVal("");
          //setAwbTrackingData(data.data);
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const { mutate: mutateOveredgeAwb } = useMutation((awbId) => GetCommanWay("/admin/proof_of_delivery/overedge/" + awbId, {}, {}), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        UseToast("Overedge Success", "success");
        mutateSearchAwb(awbScanVal);
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const getTRline = (name, value) => {
    return (
      <tr>
        <td className="text-right pr-5">{name}</td>
        <td>{value}</td>
      </tr>
    );
  };
  const getChargeableWeight = (weight, product_code, ll, bb, hh) => {
    ll = Number(ll);
    bb = Number(bb);
    hh = Number(hh);
    let dWeight = (ll * bb * hh) / (product_code == "X" ? 2700 : 5000);
    return Math.max(Number(weight), dWeight);
  };

  const disableEnterKey = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
    }
  };

  return (
    <>
      <h1 className="text-center mb-4 mt-3 text-lg font-semibold underline">Overedge (Missroute)</h1>

      <div>
        {/* <div className="grid grid-cols-2 sm:grid-cols-1 gap-4 px-4"> */}
        <div className="flex gap-2 flex-wrap border p-2">
          <div className="w-full text-center flex justify-center items-center gap-4">
            Scan AWB No:{" "}
            <input
              type="text"
              value={awbScanVal}
              className="bg-blue-200 rounded"
              onKeyDown={disableEnterKey}
              onInput={(e: any) => {
                setAwbScanVal(e.target.value);
              }}
            />
            <Button
              type="button"
              className="rounded-md inline-block px-4 py-2 text-sm font-medium text-white bg-blue-800 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
              onClick={() => {
                mutateSearchAwb(awbScanVal);
              }}
            >
              Search
            </Button>
            {awbList.length && (
              <Button
                type="button"
                className="rounded-md inline-block px-4 py-2 text-sm font-medium text-white bg-green-700 hover:bg-opacity-60 focus:z-10 "
                onClick={() => {
                  //mutateOveredgeAwb(awbTrackingData.awbData?.id);
                }}
              >
                Declare Overedge
              </Button>
            )}
          </div>
        </div>

        <div>
          <table>
            <thead>
              <tr>
                <th className="px-2 border">-</th>
                <th className="px-2 border">AWB No.</th>
                <th className="px-2 border">Book_Date </th>
                <th className="px-2 border">Client</th>
                <th className="px-2 border">Shipper</th>
                <th className="px-2 border">Cgnee</th>
                <th className="px-2 border">Cgnee Addr.</th>
                <th className="px-2 border">Origin</th>
                <th className="px-2 border">Destination</th>
                <th className="px-2 border">Weight</th>
                <th className="px-2 border">Motherbag</th>
              </tr>
            </thead>
            <tbody>
              {awbList.map((awbTrackingData, i) => {
                return (
                  <tr>
                    <td className="px-2 border-x">
                      <Button
                        type="button"
                        className="rounded-md inline-block px-3 py-1 font-medium text-white bg-red-700 hover:bg-opacity-60 focus:z-10 text-xl"
                        onClick={() => {
                          const updatedData = awbList.filter((item) => item.awbData?.awb_no !== awbTrackingData.awbData?.awb_no);
                          setAwbList(updatedData);

                          //mutateOveredgeAwb(awbTrackingData.awbData?.id);
                        }}
                      >
                        -
                      </Button>
                    </td>
                    <td className="px-2 border-x">{awbTrackingData.awbData?.awb_no}</td>
                    <td className="px-2 border-x">{awbTrackingData.bookingData?.createdAt}</td>
                    <td className="px-2 border-x">{awbTrackingData.bookingData.customer_sh}</td>
                    <td className="px-2 border-x">{awbTrackingData.bookingData.shipper_sh}</td>
                    <td className="px-2 border-x">{awbTrackingData.awbData.consignee}</td>
                    <td className="px-2 border-x">{awbTrackingData.awbData.address}</td>
                    <td className="px-2 border-x">{awbTrackingData.bookingData.shipper_city}</td>
                    <td className="px-2 border-x">{awbTrackingData.awbData.destination}</td>
                    <td className="px-2 border-x">{awbTrackingData.awbData.weight}</td>
                    <td className="px-2 border-x">{awbTrackingData?.awbData?._mother_bag_id?.mother_bag_code || "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {/*awbTrackingData.awbData?.id && (
            <div className="flex flex-col gap-4 px-4 mt-2">
              <div className=" border p-2 rounded-2xl">
                <div className="flex gap-2">
                  <table>                    
                    {getTRline("From", awbTrackingData.bookingData.shipper_city)}
                    {getTRline("To", awbTrackingData.awbData.destination)}
                    {getTRline("Client Name", awbTrackingData.bookingData.customer_sh)}
                    {getTRline("Shipper Name", awbTrackingData.bookingData.shipper_sh)}
                    {getTRline("Shipper Addr", awbTrackingData.bookingData.shipper_address)}
                    {getTRline("Consignee Name", awbTrackingData.awbData.consignee)}
                    {getTRline("Consignee Addr", awbTrackingData.awbData.address)}
                    {getTRline("Pincode", awbTrackingData.awbData.pincode)}
                  </table>

                  <table>
                    {getTRline("Book Date", awbTrackingData.bookingData?.createdAt)}
                    
                    {getTRline("Shipper Mobile", awbTrackingData.bookingData?.consignee_mobile)}
                    {getTRline("Consignee Mobile", awbTrackingData.bookingData?.shipper_mobile)}
                    
                    {getTRline("Motherbag No", awbTrackingData?.awbData?._mother_bag_id?.mother_bag_code || "-")}
                    {getTRline(
                      <b>Current Status</b>,
                      awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.message_code
                    )}
                  </table>
                </div>
                <div className="flex justify-between mt-2 border-t pt-2">
                  <div className="flex gap-8">
                    <p>
                      Weight: <b>{awbTrackingData.awbData.weight} kg</b>
                    </p>
                  </div>

                </div>
              </div>
            </div>
          )*/}
        </div>
      </div>
    </>
  );
};

export default Overedge;
